import { createSvgComponent } from "../../icon/createSvgComponent";
import GiftBox from "@core/icon/assets/gift-box.svg";
export default createSvgComponent(GiftBox);